module.exports = __webpack_public_path__ + "img/vip2.e6eb2083.png";